import { register } from "@shopify/theme-sections";
import Slider from "../components/slider/slider";

const selectors = {
	slider: "[data-images-slider]",
	arrowNext: "[data-slider-arrow-next]",
	arrowPrev: "[data-slider-arrow-prev]",
	pagination: "[data-slider-pagination]"
};
register("images-slider", {
	slider: null,
	options: {},
	onLoad: function () {
		this.sliderContainer = this.container.querySelector(selectors.slider);

		if (!this.sliderContainer) {
			return null;
		}

		this.options = {
			slidesPerView: "auto",
			spaceBetween: 15,
			autoplay: false,
			navigation: {
				nextEl: selectors.arrowNext,
				prevEl: selectors.arrowPrev
			},
			pagination: {
				el: selectors.pagination,
				clickable: true,
				type: "bullets"
			},
			breakpoints: {
				640: {
					slidesPerView: 1.5
				},
				998: {
					slidesPerView: 2.8
				},
				1200: {
					slidesPerView: 3
				}
			}
		};

		this.slider = new Slider(this.sliderContainer, this.options);
	},
	onUnload: function () {
		if (!this.slider) {
			return null;
		}

		this.slider.destroy();
	},
	getInstance: function () {
		return this.slider.instance;
	}
});
